export default "__VITE_ASSET__BUW3lGtL__"